import React, { useState } from 'react';
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import './Popup.css';

const PopupComponent = React.forwardRef((props, ref) => {
  const [open, setOpen] = useState(false);
  const [popupTitle, setPopupTitle] = useState('');
  const [popupDescription, setPopupDescription] = useState('');
  const [resolvePromise, setResolvePromise] = useState(null);

  // Open the popup and return a promise
  const show = ({ title, description }) => {
    return new Promise((resolve) => {
      setPopupTitle(title); // Update state with title
      setPopupDescription(description); // Update state with description
      setOpen(true);
      setResolvePromise(() => resolve);
    });
  };

  React.useImperativeHandle(ref, () => ({
    show,
  }));

  const handleConfirm = () => {
    if (resolvePromise) {
      resolvePromise(true);
    }
    setOpen(false);
  };

  const handleCancel = () => {
    if (resolvePromise) {
      resolvePromise(false);
    }
    setOpen(false);
  };

  return (
    <Popup
      open={open}
      closeOnDocumentClick={false}
      modal
      contentStyle={{
        width: '300px',
        borderRadius: '10px',
        padding: '0',
        boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)',
      }}
    >
      <div className="popup-container">
        <div className="popup-icon">
          <span role="img" aria-label="warning">
            ⚠️
          </span>
        </div>
        <div className="popup-content">
          <h3 className="popup-title">{popupTitle}</h3>
          <p className="popup-description">{popupDescription}</p>
        </div>
        <div className="popup-actions">
          <button className="popup-button cancel" onClick={handleCancel}>
            Cancel
          </button>
          <button className="popup-button confirm" onClick={handleConfirm}>
            Yes
          </button>
        </div>
      </div>
    </Popup>
  );
});

export default PopupComponent;
